import { render, staticRenderFns } from "./file-preview-container.vue?vue&type=template&id=6bee2843&"
import script from "./file-preview-container.vue?vue&type=script&lang=js&"
export * from "./file-preview-container.vue?vue&type=script&lang=js&"
import style0 from "./file-preview-container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VImg,VSkeletonLoader})
